import { useEffect, useState } from 'react';
import * as React from "react";
import { Collapse } from "react-collapse";
import { Animations } from "../../ReactComponents/animations";
import Reveal from "react-reveal/Reveal";
import {EventListItem} from "./EventListItem/EventListItem";

interface IEventListBlockItem {
    title: string;
    subtitle: string;
    url: string;
    location: string;
    dateString: string;
}

interface IEventListBlock {
    heading: string;
    maxVisible: number;
    showAllText: string;
    eventList: IEventListBlockItem[];
}

export const EventListBlock = ({
    heading,
    maxVisible,
    showAllText,
    eventList,
}: IEventListBlock) => {
    const [isAnimationDisabled, setIsAnimationDisabled] = useState<boolean>(false);
    const [showAll, setShowAll] = useState<boolean>(false);

    const visibleEvents = showAll ? eventList : eventList.slice(0, maxVisible);

    // Effect to handle logic for checking browser support and screen size
    useEffect(() => {
        const canUseDOM = typeof window !== "undefined";

        const checkAnimationDisabled = () => {
            if (canUseDOM) {
                const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
                setIsAnimationDisabled(!(isDesktop));
            }
        };

        checkAnimationDisabled();

        // Optional: Add event listener to handle screen size changes
        window.addEventListener('resize', checkAnimationDisabled);

        return () => {
            // Cleanup the event listener on component unmount
            window.removeEventListener('resize', checkAnimationDisabled);
        };
    }, []);

    return (
        <section className="EventListBlock wrapper">
            {heading && <h2 className="EventListBlock__title">{heading}</h2>}
            <div className="EventListOverview">
                <Collapse isOpened={true} springConfig={Animations.spring}>
                    {visibleEvents.length > 0 && (
                        <ul className="EventListBlock__list EventListBlock__grid--center">
                            {visibleEvents.map((eventListItem: IEventListBlockItem, i: number) => {
                                return (
                                    <Reveal
                                    key={eventListItem.url + i}
                                    style={{ transitionDelay: i * 40 + 10 }}
                                    disabled={isAnimationDisabled}
                                    effect="cardAnimation"
                                    >
                                        <li>
                                            <EventListItem
                                                {...eventListItem}
                                            />
                                        </li>
                                    </Reveal>
                                
                            );
                            })}
                        </ul>
                    )}
                </Collapse>
            </div>
            {eventList.length > maxVisible && !showAll &&
                    <div className="EventListOverview__buttonContainer scrollObserver">
                        <a className="button--secondary" onClick={() => setShowAll(true)}>
                            {showAllText}
                        </a>
                    </div>
            }
        </section>
    );
};

export default EventListBlock;
